module.exports = __webpack_public_path__ + "static/media/z&v2.0c37623b.jpg";